@use '../../../app/styles/common/mixins';

.mainContent {
  display: flex;
  margin-top: 16px;
  margin-bottom: 36px;
  gap: 60px;

  @include mixins.tablet {
    margin-top: 24px;
    margin-bottom: 60px;
  }

  @include mixins.desktop {
    margin-bottom: 84px;
  }
}

// Mobile listing pages: the feed's own 12px padding-top is the whole chips → feed
// gap, so the slider's default bottom padding is dropped. Scoped under .mainContent
// to outweigh the ChipSlider base rule; the sticky TopBar row keeps the default.
.mainContent .filtersChipsRow {
  padding-bottom: 0;

  @include mixins.laptop {
    padding-bottom: var(--spasing16);
  }
}

.asideContent {
  flex: 0 1 340px;
}

.feedContent {
  flex: 1;

  // Notice: Fix for Safari. DO NOT REMOVE
  min-width: 0;
}

.banner {
  margin-bottom: var(--spasing12);

  @include mixins.tablet {
    margin-bottom: var(--spasing40);
  }
}
